/*
 * Copyright (c) 2019. Nedaware SL
 */

import {WidgetType} from "./widget";
import {TestWidget2Component} from "./test-widget2/test-widget2.component";


/**
 * Nedaware S.L.
 * @author David Campos Rodríguez <david.campos.r96@gmail.com>
 */
export const AVAILABLE_WIDGETS: WidgetType[] = [
    TestWidget2Component
];
